<template>
  <div id="summary-main-text">
    <div class="first-row">
      <div class="box-text">{{ $t("summaryScreen.boxText") }}</div>
      <div class="moving-icon">
        <arrow-icon
          class="moving"
          :movingType="movingType"
          v-if="moving !== 0"
        />
        <img class="moving" src="/static/icons/atStore-icon.svg" v-else />
      </div>
      <div class="moving-text">
        {{ $t(`summaryScreen.moving.${moving}`) }}
      </div>
    </div>
    <div class="second-row">
      <div class="partner" v-if="partner">
        <div class="partner-name">
          {{ partner.name }}
        </div>
        <div class="partner-location" v-if="partner.location">
          {{ partner.location }}
        </div>
      </div>
      <div class="store" v-else>
        {{ $t("summaryScreen.storeText") }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SummaryMainText",
  props: {
    partner: {
      type: Object,
      required: false
    },
    moving: {
      type: Number,
      required: true
    }
  },
  components: {},
  data: () => ({}),
  created() {},
  computed: {
    movingType() {
      return this.moving === 1 ? "from" : "to";
    }
  },
  methods: {}
};
</script>

<style lang="scss" scoped>
#summary-main-text {
  .first-row {
    display: flex;
    align-items: flex-end;
    justify-content: center;
    font-size: 18px;
    margin-bottom: 10px;
    .box-text {
      margin-right: 10px;
    }
    .moving-icon {
      margin-right: 10px;
      .moving {
        width: 60px;
      }
    }
  }
  .second-row {
    font-size: 25px;
    font-weight: 550;
    text-align: center;
  }
}
</style>
